import { axiosPost } from '@/api/AxiosApi';

// 사용자 계정 탈퇴(신청)
// 사용자계정에 잔액(포인트/코인)이 없는 경우 탈퇴처리 - 잔액(포인트/코인)이 존재하는경우 탈퇴 신청 처리된다.
export const withdrawalUser = async (password: string) => {
  const payload = {
    path: '/v1/users/wthdr',
    body: { user_pw: password },
  };
  const { data: re } = await axiosPost(payload);
  return re;
};

export const withdrawalUserSns = async (email: string) => {
  const payload = {
    path: '/v1/users/wthdrSns',
    body: { email }
  };
  const { data: re } = await axiosPost(payload);
  return re;
};
